var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46008 2C1.25008 2 1.04008 2.08 0.870083 2.21C0.430083 2.55 0.350083 3.18 0.690083 3.61V3.62L6.00008 10.42V16.41L8.29008 18.71C8.68008 19.1 9.32008 19.1 9.71008 18.71C10.1001 18.32 10.1001 17.68 9.71008 17.29L8.00008 15.59V9.73L2.27008 2.39C2.17435 2.26686 2.0514 2.16757 1.91087 2.09991C1.77034 2.03225 1.61604 1.99805 1.46008 2ZM14.0001 9V16.88C14.0401 17.18 13.9401 17.5 13.7101 17.71C13.6176 17.8027 13.5077 17.8762 13.3867 17.9264C13.2657 17.9766 13.1361 18.0024 13.0051 18.0024C12.8741 18.0024 12.7444 17.9766 12.6235 17.9264C12.5025 17.8762 12.3926 17.8027 12.3001 17.71L10.2901 15.7C10.181 15.5934 10.0981 15.463 10.0478 15.319C9.99747 15.175 9.98115 15.0213 10.0001 14.87V9H9.97008L4.21008 1.62C4.04769 1.41153 3.97442 1.14726 4.00627 0.88493C4.03812 0.622602 4.17252 0.383546 4.38008 0.22C4.57008 0.08 4.78008 0 5.00008 0H19.0001C19.2201 0 19.4301 0.08 19.6201 0.22C19.8276 0.383546 19.962 0.622602 19.9939 0.88493C20.0257 1.14726 19.9525 1.41153 19.7901 1.62L14.0301 9H14.0001Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1671586770ed370bca49a52977d9534e.svg";
export { ForwardRef as ReactComponent };